import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import {Button, Alert} from 'react-bootstrap';
import {injectIntl, FormattedMessage} from 'react-intl';

import Spinner from 'react-spinkit';

import SpogLink from 'router-with/ui/SpogLinkRoute';
import Input from 'components/ui/form/Input';

import 'style/components/login/login-form.scss';

/** Component to render a Reset password form */
class ResetPasswordForm extends Component {

    static propTypes = {
        isResetting:  PropTypes.bool, // True when the form is fetching
        resetError:   PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // The last happened error
        resetSuccess: PropTypes.bool, // The last happened error
        onSubmit:     PropTypes.func // Listener when the form is submitted
    };

    static defaultProps = {
        resetSuccess: false
    };

    state = {
        email: '' // The current email text
    };

    /**
     * Set the initial state
     * Set this to handlers
     */
    componentWillMount() {
        this.handlerSubmit = this.handlerSubmit.bind(this);
        this.handlerEmailInput = this.handlerEmailInput.bind(this);
    }

    /**
     * Focus the user field
     */
    componentDidMount() {
        ReactDOM.findDOMNode(this.refs.email).focus();
    }

    /**
     * Do the submit action
     * @param {Event} e The event object
     */
    handlerSubmit(e) {
        e.preventDefault();

        const
            {
                email
            } = this.state,
            {
                isResetting,
                onSubmit
            } = this.props;

        !isResetting && onSubmit && onSubmit(email);
    }

    /**
     * Update the email state
     * @param {String} email The new email
     */
    handlerEmailInput(email) {
        this.setState({email});
    }

    /**
     * Shows the alert whenever any error has come from the reducer.
     */
    renderAlert() {
        const {resetError} = this.props;

        return resetError ?
            <Alert bsStyle="danger">{resetError}</Alert> :
            null;
    }

    /**
     * Shows the success screen whenever the server returns a valid response.
     */
    renderSuccess() {
        const loginUrl = '/login';
        const {email} = this.state;
        const {resetSuccess, intl: {formatMessage}} = this.props;

        if (email && resetSuccess) {
            return (<div>
                <Alert bsStyle="success">{formatMessage({id: 'label.mail_confirm'}, {email})}</Alert>
                <SpogLink to={loginUrl}>
                    <div className="text-muted text-right">
                        <FormattedMessage id="login.back_to_login"/>
                    </div>
                </SpogLink>
            </div>);
        }

        return null;
    }

    /**
     * Displays the UI whenever the elements are re-rendering in the resetting call.
     */
    renderButtonContent() {
        const {isResetting, intl: {formatMessage}} = this.props;

        return isResetting ?
            [
                <Spinner key="login-spinner" name="circle" className="login-spinner" fadeIn="none" />,
                <span key="login-spinner-text" className="login-spinner-text">{formatMessage({id: 'spinner.loading'})}</span>
            ] :
            formatMessage({id: 'btn.submit_button'});
    }

    render() {
        const
            {resetSuccess, isResetting, intl: {formatMessage}} = this.props,
            returnUrl = '/login',
            {email} = this.state;

        const title = (<h2 className="mb-xl">
            <FormattedMessage id="title.recover_password_mail"/>
        </h2>);

        if (resetSuccess) {
            return <div>{title}{this.renderSuccess()}</div>;
        }

        return (<div>
            { title }
            { this.renderAlert() }
            <form onSubmit={ this.handlerSubmit }>
                <Input
                    ref="email"
                    name="email"
                    bsSize="large"
                    autoFocus
                    placeholder={formatMessage({id: 'title.email'})}
                    glyph="envelope"
                    value={email}
                    disabled={isResetting}
                    onChange={this.handlerEmailInput}
                />

                <Button
                    className="btn-login btn-loginNewColor"
                    bsSize="large"
                    bsStyle="login"
                    block
                    type="submit"
                    disabled={isResetting}
                >
                    {this.renderButtonContent()}
                </Button>
                <SpogLink to={returnUrl}>
                    <div className="text-right link-login">
                        <FormattedMessage id="label.return_to_login"/>
                    </div>
                </SpogLink>
            </form>
        </div>);
    }
}

export default injectIntl(ResetPasswordForm);





// WEBPACK FOOTER //
// ./src/components/login/ResetPasswordForm.jsx